import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const CrowdContentOrderFilter = (props) => {
  const {
    contentOrders,
    filterName,
    setFilter,
    resetFilter
  } = props;

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedName, setSelectedName] = useState(null);

  const toggle = () => setDropdownOpen(!dropdownOpen);

  const uniqueNames = Array.from(
    new Map(
      contentOrders
        .map(order => {
          const parent = order?.meta?.project?.meta?.parent;
          const name = parent?.local?.business?.name?.trim();

          if (!parent || !name) return null;
          return [parent['_id'], [parent['_id'], name]];
        })
        .filter(entry => entry !== null)
    ).values()
  ).sort((a, b) => a[1].localeCompare(b[1]));

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret>
        {filterName || "Select Name"}
      </DropdownToggle>
      <DropdownMenu>
        {filterName && (
          <span>
            <DropdownItem
              onClick={() => {
                resetFilter();
              }}
            >
              Reset Filter
            </DropdownItem>
            <DropdownItem divider />
          </span>
        )}

        {uniqueNames.length === 0 ? (
          <DropdownItem disabled>
            None
          </DropdownItem>
        ) : (
          uniqueNames.map(([id, name]) => (
            <DropdownItem
              key={id}
              onClick={() => {
                setSelectedName(name);
                setFilter(name)
              }}
            >
              {name}
            </DropdownItem>
          ))
        )}
      </DropdownMenu>

      {filterName && (
        <span>
          <FontAwesomeIcon
            className="ml-2"
            icon={faTimes}
            onClick={() => {
              resetFilter();
            }}
          />
        </span>
      )}
    </Dropdown>
  );
};

export default CrowdContentOrderFilter;
